import React, { useEffect } from "react";
// Importing Packages
import { v4 as uuidv4 } from "uuid";

//Importing Libraries
var Highcharts = require("highcharts");
// require('highcharts/highmaps')(Highcharts);
require("highcharts/modules/map")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);

function LineChart() {
  let id = generateRandomGuid();
  function generateRandomGuid() {
    return uuidv4();
  }

  useEffect(() => {
    function renderLineChart() {
      // Line Chart
      Highcharts.chart(`lc-${id}`, {
        chart: {
          type: "area",
          height: 200,
          backgroundColor: null,
        },

        title: {
          text: " ",
        },
        credits: {
          enabled: false,
        },

        exporting: {
          enabled: false,
        },
        xAxis: {
          categories: ["0-25%", "25-50%", "50-75%", "75-100%"],
          lineColor: "#424B51",
          lineWidth: 1,
          labels: {
            style: {
              fontSize: "12px",
              fontWeight: "700",
              color: "#24A0D9",
            },
          },
        },

        yAxis: {
          tickInterval: 10,
          borderWidth: 0,
          title: false,
          labels: {
            formatter: function () {
              return this.value - 0;
            },
            style: {
              fontSize: "12px",
              fontWeight: "700",
              color: "#24A0D9",
            },
          },
          gridLineColor: "transparent",
          lineColor: "#424B51",
          lineWidth: 1,
        },

        legend: {
          enabled: false,
          layout: "vertical",
          backgroundColor: "#FFFFFF",
          floating: true,
          align: "left",
          x: 100,
          verticalAlign: "top",
          y: 70,
        },
        tooltip: {
          headerFormat: "<b>{series.name}</b><br/>",
          pointFormat: "{point.category}: {point.y}",
        },
        series: [
          {
            name: "NWC",
            data: [40, 35, 15, 24],
            lineColor: "#24A0D9",
            lineWidth: 1,
            fillColor: {
              linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
              stops: [
                [0, "rgba(28, 112, 165, 1)"],
                [1, "rgba(49, 56, 61, 1)"],
              ],
            },
          },
        ],
      });
    }

    renderLineChart();
  }, [id]);

  return <div id={`lc-${id}`}></div>;
}

export default LineChart;
